(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("dome-registry-core", [], factory);
	else if(typeof exports === 'object')
		exports["dome-registry-core"] = factory();
	else
		root["dome-registry-core"] = factory();
})(self, () => {
return 